import { render, staticRenderFns } from "./post-detail.vue?vue&type=template&id=22b029a8&scoped=true"
import script from "./post-detail.vue?vue&type=script&lang=js"
export * from "./post-detail.vue?vue&type=script&lang=js"
import style0 from "./post-detail.vue?vue&type=style&index=0&id=22b029a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b029a8",
  null
  
)

export default component.exports